module.exports = __webpack_public_path__ + "src/app/assets/images/manning.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/manning.jpg
// module id = 632
// module chunks = 0